// extracted by mini-css-extract-plugin
export default {"calendar":"DateModal-module__calendar___vaFPz","footer":"DateModal-module__footer___AaujO","modal":"DateModal-module__modal___rHSuM"};